import React from 'react'
import HelpButton from './HelpButton'

import instructionsPDF from '../../content/files/instructions.pdf'

function ChartHelp() {
    return (
        <React.Fragment>
            <HelpButton modelId = 'probe-help' />

            <div class = "modal fade" id = "probe-help" role = "dialog">
                <div class = "modal-dialog modal-lg">
                    <div class = "modal-content">
                        <div class = "modal-header">
                            <h3 class = "modal-title">Chart Help</h3>
                            <button type = "button" class = "close" data-dismiss = "modal">&times;</button>
                        </div>
                        <div class = "modal-body row text-left" style={{marginLeft: '10px', marginRight: '10px', fontSize: '17px'}}>
                            <h3 style={{marginTop: '3px'}}>Tips for Understanding the Student’s Chart</h3>
                            <ul>
                                <li style={{paddingBottom: '10px'}}>On the chart is the <span>words per minute</span> in blue going up as the <span>errors per minute</span> in red go down showing student progress.</li>

                                <li style={{paddingBottom: '10px'}}>When you scroll down, you can see the <strong>"Raw Exercise Records"</strong> and to the right you can change the order between <strong>ascending or descending.</strong></li>

                                <li style={{paddingBottom: '10px'}}><strong>Data points are connected</strong> when the same exercise is done on consecutive days.</li>

                                <li><strong>Optimal growth with Great Leaps comes from working with a student 5 days a week. Less than 3 days per week is not using it with fidelity.</strong></li>
                            </ul>
                            <h3 style={{width: '100%'}}>Watch</h3>
                            <p style={{marginBottom: '25px'}}>
                                <a href = "https://www.youtube.com/watch?v=-NtuH0q4QpU&t=84s" target="_blank">Student’s Chart Explained</a>
                            </p>
                            <p class = "text-center">For more in depth instructions, <a href={instructionsPDF} target="_blank">click here</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ChartHelp
